import { lazy } from 'react';
import { homeStrings } from '../../../../components/StringBundle';
import { roles } from '../../../../constants/roles';

// Power BI reports come from the backend (power-bi/my-reports, managed in Power BI admin).
// In-app dashboards render their own component instead of an embed URL, so they're listed here.
const CustomDashboard = lazy(() => import('./custom-dashboard'));

export const inAppDashboards = [
  {
    id: 'forecastAttainment',
    label: homeStrings.forecastAttainmentDashboard,
    component: CustomDashboard,
    // A Set, so checking the current user's role is a direct lookup rather than a scan of the list.
    roles: new Set([
      roles.admin,
      roles.managingDirector,
      roles.BDManager,
      roles.BusinessDevelopmentHod,
      roles.BusinessDevelopmentManager,
      roles.BDDomestic,
      roles.BusinessDevelopmentExecutive,
      roles.managerCommerical,
      roles.ProductionManager,
      roles.executiveLeadership,
      roles.factorymanager,
      roles.GmProjects,
      roles.marketingExecutive,
    ]),
  },
];
